import React, { Component } from 'react';
import pubsub from 'pubsub-js';
import { Translate, Localize } from 'react-redux-i18n';
import {
  NavDropdown, MenuItem, Grid, Row, Col, Panel, Button, Tabs, Tab,
  ButtonToolbar, Breadcrumb, Input, Dropdown } from 'react-bootstrap';
import { connect } from 'react-redux';
import { SkyLightStateless } from 'react-skylight';

import HeaderRun from './Header.run'
import Modals from './baseModals';
import checkPermission from '../Common/permissions';
import { signoutUser} from '../../actions/auth_actions';
// import { fetchWarehouses } from '../../actions/warehouses_actions';
import { changeToChinese, changeToEnglish } from '../../actions/language_actions';

import { ROOT_URL, ROOT_API_URL } from '../../actions/root_url';

const isAFM = ROOT_API_URL === 'https://afm-scm.truckxi.com/api/' || ROOT_URL === 'https://afm-scm.truckxi.com/api/';
const isHF = ROOT_API_URL === 'https://hfstage-erp.truckxi.com/api/' || ROOT_URL === 'https://hfstage-erp.truckxi.com/api/';
const isOCM = ROOT_API_URL === 'https://ocm-scm.truckxi.com/api/'|| ROOT_URL === 'https://ocm-scm.truckxi.com/api/';

//import {logoStyle, logo1Style} from '../Common/style';

class Header extends Component {
    constructor() {
        super();
        this.state = {
          confirmRefreshOpen: false,
          warehouseLocationDisplay: null,
          warehouseLocation: null,
          warehouseLocationSelection: [],
          
          companyLocationDisplay: null,
          companyLocation: null,
          companyLocationSelection: [],
        };
        this.pageRefreshOpen = this.pageRefreshOpen.bind(this);
        this.pageRefreshClose = this.pageRefreshClose.bind(this);
    }
    static contextTypes = {
      router: React.PropTypes.object
    }

    componentDidMount() {
        HeaderRun();
        // this.props.fetchWarehouses();
    }

    toggleUserblock(e) {
        e.preventDefault();
        pubsub.publish('toggleUserblock');
    }

    logOut() {
        this.props.signoutUser();
    }

    pageRefreshOpen() {
        this.setState({ confirmRefreshOpen: true });
    }
    pageRefreshClose() {
        this.setState({ confirmRefreshOpen: false });
    }
    pageRefreshConfirm() {
        this.setState({ confirmRefreshOpen: false });
        setTimeout(function() {
            window.location.reload(true);
        }, 2000);
        window.location.pathname = `/`;
    }

    render() {
        let { 
          warehouseLocation, warehouseLocationDisplay, warehouseLocationSelection,
          companyLocation, companyLocationDisplay, companyLocationSelection,
         } = this.state;
        if (isAFM) {
          if (warehouseLocationSelection.length < 1) {
              if (checkPermission('view_belongwarehouse_All')) {
                  warehouseLocationSelection.push(
                      {
                          label: <Translate value="all_locations" />,
                          value: '',
                      },
                      {
                          label: "Beaverton",
                          value: 'Beaverton',
                      },
                      {
                          label: "Bellevue",
                          value: 'Bellevue',
                      },
                      {
                          label: "Seattle",
                          value: 'Seattle',
                      },
                  );
                  this.setState({ warehouseLocationSelection });
              } else if (checkPermission('view_belongwarehouse_Beaverton')) {
                  warehouseLocationSelection.push(
                      {
                          label: "Beaverton",
                          value: 'Beaverton',
                      },
                  );
                  this.setState({ warehouseLocationSelection });
              } else if (checkPermission('view_belongwarehouse_Bellevue')) {
                  warehouseLocationSelection.push(
                      {
                          label: "Bellevue",
                          value: 'Bellevue',
                      },
                  );
                  this.setState({ warehouseLocationSelection });
              } else if (checkPermission('view_belongwarehouse_Seattle')) {
                  warehouseLocationSelection.push(
                      {
                          label: "Seattle",
                          value: 'Seattle',
                      },
                  );
                  this.setState({ warehouseLocationSelection });
              }
          }
  
          if (localStorage.getItem('warehouseLocation') === '' || !localStorage.getItem('warehouseLocation')) {
              warehouseLocation = '';
              warehouseLocationDisplay = <Translate value="all_locations" />;
          } else if (localStorage.getItem('warehouseLocation') === 'Beaverton') {
              warehouseLocation = 'Beaverton';
              warehouseLocationDisplay = 'Beaverton';
          } else if (localStorage.getItem('warehouseLocation') === 'Bellevue') {
              warehouseLocation = 'Bellevue';
              warehouseLocationDisplay = 'Bellevue';
          } else if (localStorage.getItem('warehouseLocation') === 'Seattle') {
              warehouseLocation = 'Seattle';
              warehouseLocationDisplay = 'Seattle';
          }
        }

        const handleWarehouseLocationChange = (el) => {
            let { warehouseLocationDisplay, warehouseLocation } = this.state;
            warehouseLocationDisplay = el.label;
            warehouseLocation = el.value;
            localStorage.setItem('warehouseLocation', warehouseLocation);
            this.setState({ warehouseLocationDisplay, warehouseLocation });
            window.location.reload();
            // window.location.pathname = `/`;
        }

        const ddAlertTitle = (
            <span>
                <em className="fa fa-gear"></em>
            </span>
        )
        const langIcon = (
            <span>
                <em className="fa fa-language"></em>
            </span>
        )
        const refreshDialogueStyle = {
            width: '450px',
            height: '200px',
            marginLeft: '-10%'
        }
        const refresh_system = (<Translate value="refresh_system" />);

        return (
            <header className="topnavbar-wrapper">
                { /* START Top Navbar */ }
                <nav role="navigation" className="navbar topnavbar">
                    { /* START navbar header */ }
                    <div className="navbar-header">
                        <a href="#/" className="navbar-brand">
                            <div className="brand-logo text-center">
                                {!isHF && <label>SCM</label>}
                                {isHF && <label>ERP</label>}
                            </div>
                            <div className="brand-logo-collapsed">
                                <img src="/img/logo1.png" alt="App Logo" className="img-responsive logo1Style" />
                            </div>
                        </a>
                    </div>
                    { /* END navbar header */ }
                    { /* START Nav wrapper */ }
                    <div className="nav-wrapper">
                        { /* START Left navbar */ }
                        <ul className="nav navbar-nav">
                            <li>
                                { /* Button used to collapse the left sidebar. Only visible on tablet and desktops */ }
                                <a href="#" data-trigger-resize="" data-toggle-state="aside-collapsed" className="hidden-xs">
                                    <em className="fa fa-navicon"></em>
                                </a>
                                { /* Button to show/hide the sidebar on mobile. Visible on mobile only. */ }
                                <a href="#" data-toggle-state="aside-toggled" data-no-persist="true" className="visible-xs sidebar-toggle">
                                    <em className="fa fa-navicon"></em>
                                </a>
                            </li>
                            { /* START User avatar toggle
                            <li>
                                Button used to collapse the left sidebar. Only visible on tablet and desktops
                                <a id="user-block-toggle" href="#" onClick={ this.toggleUserblock }>
                                    <em className="fa fa-user"></em>
                                </a>
                            </li>
                              END User avatar toggle */}
                        </ul>
                        { /* END Left navbar */ }
                        { /* START Right Navbar */ }
                        <ul className="nav navbar-nav navbar-right">
                            {
                                isAFM &&
                                <li style={{ padding: '11px' }}>
                                    <Dropdown>
                                        <Dropdown.Toggle style={{ width: '120px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                                            {warehouseLocationDisplay}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="super-colors">
                                            {warehouseLocationSelection.map(el => {
                                                return (
                                                    <MenuItem onClick={() => handleWarehouseLocationChange(el)}>{el.label}</MenuItem>
                                                )
                                            })}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </li>
                            }
                            <li>
                                <a onClick={this.pageRefreshOpen}>
                                    <em className='fa fa-refresh' />
                                </a>
                            </li>
                            { /* START Language Menu */}
                          <NavDropdown noCaret title={ langIcon }>
                            <MenuItem className="animated flipInX" event key={2.1} onClick={(e) => {
                                e.preventDefault();
                                this.props.changeToEnglish()}}>English</MenuItem>
                              <MenuItem className="animated flipInX" event key={2.2} onClick={(e) => {
                                e.preventDefault();
                                this.props.changeToChinese()}}>中文</MenuItem>
                          </NavDropdown>
                          { /* END Language Menu */ }
                            { /* Search icon
                            <li>
                                <a href="#" data-search-open="">
                                    <em className="icon-magnifier"></em>
                                </a>
                            </li>
                              End Search icon */ }
                            { /* START Alert menu */ }
                            <NavDropdown noCaret eventKey={ 3 } title={ ddAlertTitle } id="basic-nav-dropdown" >
                                { /*}<MenuItem onClick={ () => { this.context.router.push('/dashboard')} } className="animated flipInX" eventKey={3.3}><Translate value="dashboard" /></MenuItem>
                                <MenuItem divider /> */ }
                                <MenuItem onClick={this.logOut.bind(this) } className="animated flipInX" eventKey={3.3}><Translate value="logout" /></MenuItem>
                            </NavDropdown>
                            { /* END Alert menu */ }
                            { /* START Offsidebar button
                            <li>
                                <a href="#" data-toggle-state="offsidebar-open" data-no-persist="true">
                                    <em className="icon-notebook"></em>
                                </a>
                            </li>
                             END Offsidebar menu */ }
                        </ul>
                        { /* END Right Navbar */ }
                    </div>
                    { /* END Nav wrapper */ }
                    { /* START Search form
                    <form role="search" action="search.html" className="navbar-form">
                        <div className="form-group has-feedback">
                            <input type="text" placeholder="Type and hit enter ..." className="form-control" />
                            <div data-search-dismiss="" className="fa fa-times form-control-feedback"></div>
                        </div>
                        <button type="submit" className="hidden btn btn-default"><Translate value="submit" /></button>
                    </form>
                     END Search form */ }
                </nav>
                { /* END Top Navbar */ }
                <Modals />

                <SkyLightStateless dialogStyles={refreshDialogueStyle} isVisible={this.state.confirmRefreshOpen} onCloseClicked={() => { this.pageRefreshClose(); }} title={refresh_system}>
                    <div>
                        <Row className="centerStyle" style={{ marginTop: '20px' }}>
                            <h4><Translate value="confirm_refresh" /></h4>
                        </Row>
                        <Row className="centerStyle">
                            <Button
                                bsStyle="danger"
                                onClick={() => { this.pageRefreshClose(); }}
                            >
                                <Translate value="cancel" />
                            </Button>
                            <span>&nbsp;&nbsp;&nbsp;</span>
                            <Button
                                bsStyle="success"
                                onClick={() => { this.pageRefreshConfirm(); }}
                            >
                                <Translate value="confirm" />
                            </Button>
                        </Row>
                    </div>
                </SkyLightStateless>
            </header>
        );
    }
}

export default connect(null, { signoutUser, changeToEnglish, changeToChinese })(Header);



// WEBPACK FOOTER //
// ./master/jsx/components/Layout/Header.jsx